import { ProductsImportContentType } from './ImportModal.types';

export const acceptedImportContentTypes = {
    [ProductsImportContentType.csv]: ['.csv'],
    [ProductsImportContentType.xlsx]: ['.xlsx'],
};
